{
  "SNOOZE_PARSER": {
    "UNITS": {
      "MINUTE": "分鐘",
      "MINUTES": "分鐘",
      "HOUR": "小時",
      "HOURS": "小時",
      "DAY": "天",
      "DAYS": "天",
      "WEEK": "週",
      "WEEKS": "週",
      "MONTH": "月",
      "MONTHS": "月",
      "YEAR": "年",
      "YEARS": "年"
    },
    "HALF": "半",
    "NEXT": "下一個",
    "THIS": "這個",
    "AT": "在",
    "IN": "在",
    "FROM_NOW": "之後",
    "NEXT_YEAR": "明年",
    "MERIDIEM": {
      "AM": "上午",
      "PM": "下午"
    },
    "RELATIVE": {
      "TOMORROW": "明天",
      "DAY_AFTER_TOMORROW": "後天",
      "NEXT_WEEK": "下週",
      "NEXT_MONTH": "下個月",
      "THIS_WEEKEND": "這個週末",
      "NEXT_WEEKEND": "下個週末"
    },
    "TIME_OF_DAY": {
      "MORNING": "早上",
      "AFTERNOON": "下午",
      "EVENING": "傍晚",
      "NIGHT": "晚上",
      "NOON": "中午",
      "MIDNIGHT": "午夜"
    },
    "WORD_NUMBERS": {
      "ONE": "一",
      "TWO": "二",
      "THREE": "三",
      "FOUR": "四",
      "FIVE": "五",
      "SIX": "六",
      "SEVEN": "七",
      "EIGHT": "八",
      "NINE": "九",
      "TEN": "十",
      "TWELVE": "十二",
      "FIFTEEN": "十五",
      "TWENTY": "二十",
      "THIRTY": "三十"
    },
    "ORDINALS": {
      "FIRST": "第一",
      "SECOND": "第二",
      "THIRD": "第三",
      "FOURTH": "第四",
      "FIFTH": "第五"
    },
    "OF": "的",
    "AFTER": "之後",
    "WEEK": "週",
    "DAY": "天"
  }
}
